import React from 'react'

import styles from './_badge.module.scss'

type BadgeColorList = 'lavender' | 'dark-green' | 'black'

export type BadgeProps = {
  /** Content of the Badge */
  children: React.ReactNode
  /** Color of the Badge */
  color: BadgeColorList
  /** Optional prop to add a test id to the Badge for QA testing */
  qaTestId?: string
}

const Badge = ({ children, color, qaTestId = 'badge' }: BadgeProps) => {
  const inlineStyle = {
    '--badge-background-color': `var(--${color})`,
  } as React.CSSProperties
  return (
    <div
      className={styles.badgeStyles}
      style={inlineStyle}
      qa-test-id={qaTestId}
    >
      {children}
    </div>
  )
}

export default Badge
